"use client";
import React from "react";
import { Button } from "./ui/moving-border";

export function MovingBorderButton({ children, clicked }) {
  return (
    <div>
      <Button
        type="submit"
        onClick={clicked}
        borderRadius="1.75rem"
        className="
          bg-blue-950 md:bg-transparent 
          text-white dark:text-white dark:border-slate-800 
          hover:bg-cyan-950 dark:hover:bg-cyan-950 
          text-xl 
          dark:bg-transparent 
          md:hover:bg-transparent 
          "
      >
        {children}
      </Button>
    </div>
  );
}
